import React, { useEffect } from "react";
import myPic from "../../assets/image/Home/me.jpg";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
function Home() {
  return (
    <>
      <div className="flex lg:flex-row md:flex-row sm:flex-col md:text-start text-center flex-col bg-gray-900 w-screen h-screen ">
        <div className="lg:px-5 md:px-5 sm:px-2 my-5 rounded-r-3xl flex md:w-2/6 sm:w-72 w-4/5 justify-center items-center md:bg-yellow-500 md:self-auto sm:self-center sm:bg-transparent self-center">
          <img
            src={myPic}
            className="w-full lg:rounded-r-xl  md:rounded-r-xl object-contain"
            alt="Yashwant_Sahu_Image"
          />
        </div>
        <div className=" flex flex-1 md:justify-center justify-normal  gap-5 lg:px-20 md:px-15 sm:px-10 px-5 flex-col ">
          {/* <h1 id="nameBox" className="lg:text-4xl md:text-3xl sm:text-2xl text-2xl font-extrabold  text-yellow-500">
            {" "}
            {"-"} <blink>|</blink>
          </h1> */}
          <TypeAnimation
            sequence={[
              // Same substring at the start will only be typed out once, initially
              "I'M YASHWANT SAHU",
              1000, // wait 1s before replacing "Mice" with "Hamsters"
              "HAPPY TO HAVE YOU HERE.",
              1000, // wait 1s before replacing "Mice" with "Hamsters"
            ]}
            wrapper="span"
            speed={50}
            className="lg:text-4xl md:text-3xl sm:text-2xl text-2xl font-extrabold  text-yellow-500"
            repeat={Infinity}
          />
          <h1 className="lg:text-4xl md:text-3xl sm:text-2xl text-xl font-extrabold text-white">
            {"{"} SOFTWARE DEVELOPER {"}"}
          </h1>
          <p className=" lg:text-xl md:text-lg text-md   text-white">
            {" "}
            {"->"} Passionate Ajmer-based web designer and front-end developer
            specializing in the MERN Stack. Leveraging TypeScript, JavaScript,
            and Git for exceptional solutions. Dedicated to intuitive,
            innovative web experiences.
          </p>
          <Link
            to={"/about"}
            className="md:self-start self-center lg:pb-10 md:pb-10 pb-28"
          >
            <button className="flex md:font-normal font-bold gap-2 items-center text-white border hover:border-white hover:bg-yellow-500 hover:text-black transition-all border-yellow-500 p-2 md:text-lg text-xl rounded-full self-start">
              More About Me
              <div className="bg-yellow-500 rounded-full lg:p-3 md:p-3 sm:p-2 p-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-6"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </button>
          </Link>
        </div>
      </div>
    </>
  );
}

export default Home;
